<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">查看专家质疑</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
        </div>

        <div class="table-section">
                <el-table :data="tableData" border style="width: 100%"
                    :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                    :cell-style="{ color: '#303133' }">
                    <el-table-column type="index" label="NO." width="80" align="center"></el-table-column>
                    <el-table-column prop="sectionName" label="标段名称"></el-table-column>
                    <el-table-column prop="userName" label="提交单位名称"></el-table-column>
                    <el-table-column prop="question" label="问题标题"></el-table-column>
                    <el-table-column prop="content" label="问题内容" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="createTime" label="提交时间" align="center"></el-table-column>
                    <el-table-column prop="lastReplyTime" label="最晚回复时间" align="center"></el-table-column>
                    <el-table-column prop="status" label="状态" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.replyContent === '' || scope.row.replyContent === null"
                                style="color: red;">未回复</span>
                            <span v-else>已回复</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="replyContent" label="回复内容" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="replyTime" label="回复时间" align="center"></el-table-column>
                </el-table>
        </div>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/projectInfo.js'
import { getSectionInfoByProjectCode } from '@/api/base/api'
import { getClarifyList } from '@/api/evaluation/api'
export default {
    name: 'ExpertQuestionView',
    data() {
        return {
            tableData: [],
            projectTitle: '',
            projectCode: this.$route.query.projectCode
        }
    },
    mounted() {
        this.getProjectInfo()
        this.getSectionInfoByProjectCode()
    },
    methods: {
        //  获取标段列表
        getSectionInfoByProjectCode() {
            getSectionInfoByProjectCode(this.projectCode).then(res => {
                if (res.code === 200) {
                    if (res.data.length > 0) {
                        let arr = res.data
                        let sectionCode = arr[0].sectionCode
                        this.getClarifyList(sectionCode)
                    }
                } else {
                    this.$message.error(res.msg || '获取标段信息失败')
                }
            }).catch(error => {
                console.error('获取标段信息失败:', error)
                this.$message.error('获取标段信息失败')
            })
        },

        //  获取标题
        async getProjectInfo() {
            this.projectTitle = await loadProjectDetail(this.projectCode);
        },
        // 返回项目流程界面
        handleBack() {
            this.$router.go(-1)
        },

        // 操作按钮点击
        handleOperation(row) {
            this.$message.info(`操作 ${row.sectionName}`)
        },
        getClarifyList(sectionCode) {
            getClarifyList(sectionCode).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

.agent-page {
    .main-content {
        margin-top: 20px;
        overflow: hidden;
    }
}
</style>
